import { Module } from "@webmotors/ioc";
import { LoggerModule } from "../logger";
import { AxiosService } from "./services";

export const HttpModule: Module = {
  name: "HttpModule",
  modules: [LoggerModule],
  providers: [AxiosService],
};
